import React, { useEffect } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';

export default function ConfigPage({ context }) {
  useEffect(() => {
    // Tell Teams the config page is ready and valid
    microsoftTeams.pages.config.registerOnSaveHandler((saveEvent) => {
      microsoftTeams.pages.config.setConfig({
        entityId: 'humulo-workshop-viewer',
        contentUrl: `${window.location.origin}/viewer`,
        suggestedDisplayName: 'Humulo Workshop',
        websiteUrl: `${window.location.origin}/viewer`,
      });
      saveEvent.notifySuccess();
    });

    microsoftTeams.pages.config.setValidityState(true);
  }, []);

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '100vh',
      background: '#0a0e17', color: '#e2e8f0', fontFamily: 'system-ui',
    }}>
      <h2 style={{ marginBottom: 8 }}>Humulo Workshop</h2>
      <p style={{ color: '#64748b', maxWidth: 400, textAlign: 'center' }}>
        Click Save to add the 3D viewer to this meeting. 
        VR participants will be able to share their view with everyone.
      </p>
    </div>
  );
}
